// extracted by mini-css-extract-plugin
module.exports = {"content":"content___3JJbF","wrapper":"wrapper___1S63f"};